import HttpCachePoolConfigProvider from './HttpCachePoolConfigProvider'
import pools from '../pools'

export const poolConfigProvider = new HttpCachePoolConfigProvider(pools)

export default {
  poolConfigProvider,
}
